var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#7F91A5",
    d: "M19.378 19.75v3.818H0V.524L19.378.522 19.38 3M4.19 6.809h3.324M4.19 12.046h2.354M4.19 17.283h5.314"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00234B",
    d: "M19.893 14.016l4.651 4.652"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.241,
    cy: 10.528,
    r: 5.814,
    stroke: "#00234B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudy);
export default __webpack_public_path__ + "static/media/icon-study.f97ec1065ff34759edd8e8a1aeef3777.svg";
export { ForwardRef as ReactComponent };